
import {mapActions, mapState} from "vuex";
import Timestamp from '../../components/shared/Timestamp.vue';
import io from "socket.io-client";

const socket = io('https://draxjb.com/', {path: '/wss'});
import VModal from '../../components/base/modal/VModal.vue'
import ApexChart from 'vue3-apexcharts'
import {defineComponent} from "vue";
import moment from "moment/moment";
import store, {ActionTypes} from "../../store";
import * as apexcharts from "apexcharts";

let labels_array = [1, 2, 3]
let title_chart = 'title'

export default defineComponent({
  components: {
    Timestamp,
    VModal,
    ApexChart,
  },

  data() {
    return {
      gridColumns: ['Strategy', 'Mid', 'Change', '3PM Close', 'chart'],
      gridData: Array,
      timestampData: 'Loading...',
      stratNameChart: '',
      index_chart_tick: {
        chart: false,
        index_id: 0
      },
      modalChart: false,
      strat_name: '',
      chart_options: {
        series: [
          {
            data: [],
          },
        ],
        chart: {
          height: 450,
          type: 'line',
          zoom: {
            type: 'xy',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
          },
        },
        colors: ['#039be5'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [2, 2, 2],
          curve: 'smooth',
        },
        title: {
          text: '',
        },
        tooltip: {
          enabled: true,
          followCursor: true,
          style: {
            fontSize: '2rem'
          }
        },
        grid: {
          row: {
            colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          type: 'numeric',
          categories: [],
          //tickPlacement: 'on',
          yAxisIndex: 0,
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true,
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: false,
            minHeight: undefined,
            maxHeight: 120,
            style: {
              colors: [],
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 400,
              cssClass: 'apexcharts-xaxis-label',
            },
            offsetX: 0,
            offsetY: 0,
            formatter: function (value: any) {
              return moment(labels_array[value.toFixed(0)]).format("DD/MM/YYYY, HH:mm");
            },
          },
        },
        yaxis: {
          tickAmount: 7,

        }
      },
      isFullScreen: false,
      copiedCIX: false,
    }
  },
  computed: {
    ...mapState(['user'])
  },
  created() {
    socket.emit('get_futures', this.user.id);
  },

  mounted() {
    socket.disconnect()
    socket.connect()
    socket.on('futuresgrid', (data) => {
      if (data.user_id == 16) {
        this.gridData = JSON.parse(data.futuresgrid),
            this.timestampData = data.lastupdated
      }
    }),
        window.setInterval(() => {
          socket.emit('get_futures', 16);
        }, 70)
  },
  methods: {
    ...mapActions({
      fetchStrategies: ActionTypes.FETCH_INDICES,
    }),
    getChartData(strat_name: string) {
      this.stratNameChart = strat_name
      store.dispatch(ActionTypes.SET_CHART_DATA, strat_name)
          .then(res => {
            title_chart = strat_name
            labels_array = res.data.chart_data.data_chart_index
            this.chart_options.series[0].data = res.data.chart_data.data_chart
            this.stratNameChart = strat_name
          })
    },
  },
  beforeUnmount() {
    socket.disconnect()
  }

})
